import { defineComponent, ref } from "vue";
import { V as VaFileUploadKey } from "../types-8c5c5611.mjs";
import { V as VaButton } from "../../va-button/index-1db585d5.mjs";
import { V as VaListItem, a as VaListItemSection } from "../../va-list/index-d370814a.mjs";
import { V as VaFileUploadUndo } from "../VaFileUploadUndo/index-718ae37f.mjs";
import { u as useStrictInject } from "../../../composables/useStrictInject-08ce5ce6.mjs";
import { u as useFocus } from "../../../composables/useFocus-4393f76a.mjs";
import { u as useBem } from "../../../composables/useBem-a19cd502.mjs";
import { u as useTranslation } from "../../../composables/useTranslation-67b81a6e.mjs";
const INJECTION_ERROR_MESSAGE = "The VaFileUploadListItem component should be used in the context of VaFileUpload component";
const _sfc_main = defineComponent({
  name: "VaFileUploadListItem",
  components: {
    VaListItem,
    VaListItemSection,
    VaFileUploadUndo,
    VaButton
  },
  emits: ["remove"],
  props: {
    file: { type: Object, default: null },
    color: { type: String, default: "success" },
    ariaRemoveFileLabel: { type: String, default: "$t:removeFile" }
  },
  setup(props, { emit }) {
    const {
      undo,
      disabled,
      undoDuration
    } = useStrictInject(VaFileUploadKey, INJECTION_ERROR_MESSAGE);
    const { onFocus, onBlur } = useFocus();
    const removed = ref(false);
    const removeFile = () => {
      if (undo.value) {
        removed.value = true;
        setTimeout(() => {
          if (removed.value) {
            emit("remove");
            removed.value = false;
          }
        }, undoDuration.value ?? 0);
      } else {
        emit("remove");
        removed.value = false;
      }
    };
    const recoverFile = () => {
      removed.value = false;
    };
    const computedClasses = useBem("va-file-upload-list-item", () => ({
      undo: removed.value
    }));
    return {
      ...useTranslation(),
      undo,
      removed,
      disabled,
      computedClasses,
      onBlur,
      onFocus,
      removeFile,
      recoverFile
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaFileUploadListItem.vue_vue_type_script_lang-44737000.mjs.map
